import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import Box from '@material-ui/core/Box';

const AutoStreamTracksCheckedList = ({autoTracks, checkedTracks, handleToggleTrackCheckbox}) => {
    const classes = useStyles();

    if (!autoTracks.length) {
        return (
            <div className={classes.noTracksWrapper}>
                Нет треков для воспроизведения или они не были загружены
            </div>
        )
    }

    return (
        <Box border={1} borderRadius={5} className={classes.borderWrapper}>
            <List className={classes.container} disablePadding={true}>
                {autoTracks.map((track, index) => {
                    const labelId = `checkbox-tracks-list-label-${index}`;
                    const trackName = track.name ? track.name : '-';

                    return (
                        <ListItem key={`auto-track-${index}`} dense button onClick={handleToggleTrackCheckbox(track)}>
                            <ListItemIcon>
                                <Checkbox
                                    edge='start'
                                    checked={checkedTracks.indexOf(track) !== -1}
                                    tabIndex={-1}
                                    disableRipple
                                    inputProps={{'aria-labelledby': labelId}}
                                />
                            </ListItemIcon>
                            <ListItemText id={labelId} primary={trackName}/>
                        </ListItem>
                    );
                })}
            </List>
        </Box>
    );
}

const useStyles = makeStyles((theme) => ({
    noTracksWrapper: {
        width: '100%',
        marginTop: 16
    },
    borderWrapper: {
        width: '100%',
        marginTop: 16,
        overflow: 'hidden'
    },
    container: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 200
    }
}));

export default AutoStreamTracksCheckedList;
